import React from 'react';

export default function DocsPage() {
  return (
     <div className="min-h-screen bg-slate-900 text-slate-100 px-6 py-10 font-sans">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold text-sky-400 mb-2">🧠 AI Blog Generator</h1>
        <p className="mb-6 text-lg">
          <strong>Generate professional blogs instantly using AI.</strong> Just enter a topic, select a tone and language, and let the AI do the rest!
        </p>

        {/* Features */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-sky-300 mb-3">🚀 Features</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>AI-Powered Blog Creation:</strong> Enter a topic and get a full blog post instantly.</li>
            <li><strong>Tone Customization:</strong> Choose between Friendly, Professional, or Neutral tones.</li>
            <li><strong>Multi-language Support:</strong> Generate blogs in English, Hindi, Bengali, and more.</li>
            <li><strong>Prompt Correction:</strong> Auto-fix typos like “helth” → “health”.</li>
            <li><strong>Redeem Codes:</strong> Add credits using codes like <code className="bg-slate-800 px-1 py-0.5 rounded">REDEEM10</code>.</li>
            <li><strong>Credit System:</strong> Each blog costs 1 credit to generate.</li>
            <li><strong>My Blogs:</strong> View, copy, or delete all previously generated blogs.</li>
          </ul>
        </section>

        {/* How to Use */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-sky-300 mb-3">📝 How to Use</h2>
          <ol className="list-decimal pl-6 space-y-2">
            <li><strong>Sign Up / Log In:</strong> Create your account to get started.</li>
            <li><strong>Enter a Blog Topic:</strong> Like <code className="bg-slate-800 px-1 py-0.5 rounded">Benefits of Yoga</code>.</li>
            <li><strong>Select Tone & Language:</strong> Customize how your blog sounds.</li>
            <li><strong>Click Generate:</strong> Let AI do the writing.</li>
            <li><strong>Preview & Save:</strong> Copy or save the generated content.</li>
          </ol>
        </section>

        {/* Redeem Code */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-sky-300 mb-3">🎁 Redeem Codes</h2>
          <p className="mb-2">Use codes like <code className="bg-slate-800 px-1 py-0.5 rounded">REDEEM10</code> to get free credits. Each credit = 1 blog.</p>
          <p>You can redeem each code only once per account.</p>
        </section>

        {/* Manage Blogs */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-sky-300 mb-3">💼 Manage Your Blogs</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>View your past blogs</li>
            <li>Copy content with one click</li>
            <li>Delete blogs you no longer need</li>
          </ul>
        </section>

        {/* Account Info */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-sky-300 mb-3">🔐 Your Account</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Secure login with email & password</li>
            <li>Token-based authentication</li>
            <li>Your blogs are linked to your account</li>
          </ul>
        </section>

        {/* Help Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-sky-300 mb-3">❓Need Help?</h2>
          <p className="mb-2">If you're facing issues, try the following:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Make sure you're logged in</li>
            <li>Check that you have credits left</li>
            <li>Ensure your blog prompt is valid</li>
          </ul>
          <p className="mt-2">Still need help? Contact us at <a href="mailto:milonmete07@gmail.com" className="text-sky-400 underline">support@example.com</a></p>
        </section>

        {/* Notes */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-sky-300 mb-3">📌 Notes</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>One blog = 1 credit.</li>
            <li>Blogs are generated by Gemini AI using your input.</li>
            <li>All generated content is stored securely to your account.</li>
          </ul>
        </section>

        <hr className="border-slate-600 my-6" />
        <p className="text-sm text-center text-slate-400">
          &copy; 2025 AI Blog Generator. Built with ❤️ using React, Tailwind, FastAPI, and Gemini AI.
        </p>
      </div>
    </div>
  );
}
